import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  faChevronLeft,
  faFileExcel,
  faPrint,
  faRectangleList,
  faTrashCan,
} from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {
  OccEndpointsService,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import * as _ from 'underscore';
import { CheckoutService } from '../../shared/modules/checkout/checkout.service';
import { CustomAddToCartService } from '../custom-add-to-cart.service';
import { ProductDetailsComponent } from '../custom-add-to-cart/product-details/product-details.component';
@Component({
  selector: 'app-standard-cart-confirmation',
  templateUrl: './standard-cart-confirmation.component.html',
  standalone: false,
})
export class StandardCartConfirmationComponent implements OnInit, OnDestroy {
  @ViewChild('p2') public savePopover: NgbPopover;
  orderConfirmationDetails: any;
  screenwidth: any;
  productEntries: any = [];
  estimatedDate: any;
  baseUrl: string;
  fallbackImage = '../../../../public/i18n-assets/sanofi_missing_product.jpg';
  public images: any;
  getuserData: any;
  selectedData: any;
  saveCartName: string;
  errorMsg: string;
  cartId: string;
  showCard: any;
  cardTrans: any;
  orderDetailsSub: Subscription;
  invalidNameSub: Subscription;
  saveOrderSub: Subscription;
  // icons
  faPrint = faPrint;
  faFileExcel = faFileExcel;
  faTrashCan = faTrashCan;
  faRectangleList = faRectangleList;
  faChevronLeft = faChevronLeft;
  constructor(
    private readonly checkoutService: CheckoutService,
    private readonly router: RoutingService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly addToCart: CustomAddToCartService,
    private readonly cdr: ChangeDetectorRef,
    public datepipe: DatePipe,
    private readonly modalService: NgbModal,
    private readonly translation: TranslationService
  ) {
    this.screenwidth = window.screen.width;
  }

  ngOnInit(): void {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.translation.translate('addToCartItems.card').subscribe((res) => {
      this.cardTrans = res;
    });
    this.orderDetailsSub =
      this.checkoutService.updatedStdOrderDetails$.subscribe((res) => {
        if (res) {
          this.orderConfirmationDetails = res;
          this.productEntries = [];
          this.saveCartName =
            this.orderConfirmationDetails?.shippingAddress?.companyName?.slice(
              0,
              30
            );
          for (let entries of this.orderConfirmationDetails?.entries) {
            this.estimatedDate = entries?.estimatedDeliveryDate;
            const imagesFormat = _.clone(
              _.findWhere(entries.product?.images, { format: 'thumbnail' })
            );
            if (imagesFormat) {
              imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
            }
            this.images = { PRIMARY: imagesFormat };
            entries = { ...entries, ...this.images };
            this.productEntries.push(entries);
          }
          this.showCard = '';
          if (this.orderConfirmationDetails?.paymentInfo) {
            this.showCard =
              this.orderConfirmationDetails?.paymentInfo?.cardNumber.substring(
                6,
                10
              );
          }
        }
      });
    this.cdr.detectChanges();
  }
  billingAccount(): void {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Account information');
  }
  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = '';
    this.saveCartName =
      this.orderConfirmationDetails?.shippingAddress?.companyName?.slice(0, 30);
  }

  saveOrder(): void {
    const reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    if (this.saveCartName && RegExp(reg).test(this.saveCartName)) {
      this.addToCart.saveOrderDetails(
        this.saveCartName,
        this.orderConfirmationDetails?.code
      );
      this.invalidNameSub = this.addToCart.invalidOrderName$.subscribe(
        (res) => {
          if (res) {
            for (const error of res?.error?.errors) {
              this.errorMsg = error?.message;
            }
          }
        }
      );
      this.saveOrderSub = this.addToCart.saveOrderSuccess$.subscribe((res) => {
        if (res) {
          if (this.savePopover) {
            this.savePopover.close();
          }
          this.errorMsg = '';
          this.saveCartName =
            this.orderConfirmationDetails?.shippingAddress?.companyName?.slice(
              0,
              30
            );
        }
      });
    } else {
      if (this.saveCartName) {
        this.errorMsg = 'Save cart name is not valid.';
      } else {
        this.errorMsg = 'Cart name cannot be blank';
      }
    }
  }
  exportXls() {
    const cartProducts = [];
    for (const entries of this.productEntries) {
      cartProducts.push({
        Customer: this.orderConfirmationDetails?.soldtoAddress?.unitID,
        'Material ID': entries?.product?.code,
        Quantity: entries?.quantity,
        'PO Number':
          this.orderConfirmationDetails?.purchaseOrderNumber === ''
            ? `WWW:${this.datepipe.transform(
                this.orderConfirmationDetails?.created,
                'dd/MM/yyyy'
              )}`
            : this.orderConfirmationDetails?.purchaseOrderNumber,
      });
    }
    this.addToCart.downloadXls(cartProducts, 'Order confirmation');
  }
  omit_special_char(event) {
    this.errorMsg = '';
    const reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    return new RegExp(reg).test(event.key);
  }
  productDetails(productDetails): void {
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: 'product-details-modal',
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = '';
    modalRef.componentInstance.unitSection = 'NoUnits';
  }
  ngOnDestroy() {
    this.saveOrderSub?.unsubscribe();
    this.invalidNameSub?.unsubscribe();
    this.orderDetailsSub?.unsubscribe();
  }
}
